import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import styles from "./ApplicationStatus.module.scss";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ApprovedApplication = ({ t, i18n }) => {
  const location = useLocation();
  const chequeStatus = location?.state?.chequeStatus;
  const currentStatus = location?.state?.currentStatus;
  const [date, setDate] = useState(null);
  const [approvedStatus, setApprovedStatus] = useState(null);

  const datesData = useSelector((state) => state.datesReducer);
  let currentLanguageDates;
  if (datesData) {
    currentLanguageDates = datesData[i18n.language];
  }

  const formatDate = (date, language) => {
    const day = date.getDate();
    const month = date.toLocaleString(language, { month: 'long' });
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  useEffect(() => {
    if (location?.state) {
      setApprovedStatus(chequeStatus);
      if (currentStatus?.statusDate) {
        const dateObj = new Date(currentStatus.statusDate);
        const formattedDate = formatDate(dateObj, i18n.language);
        setDate(formattedDate);
      } else {
        setDate(""); 
      }
    }
  }, [location?.state?.chequeStatus, chequeStatus, currentStatus?.statusDate, i18n.language]);

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "We’ve approved your application - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Nous avons approuvé votre demande – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  return (
    <div key={i18n.language}>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>
            <div className="container">
              <div style={{ display: "flex" }}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "30px"
                  }}
                >
                  <div className={"col-xs-1 " + styles["success_margin_right"]}>
                    <i
                      className="fa fa-check-circle fa-2x"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div
                    style={{
                      flexGrow: 1,
                      backgroundColor: "green",
                      width: "5px"
                    }}
                  />
                </div>

                <div style={{ flexGrow: 1 }}>
                  <div className="col-xs-12">
                    <div className="row">
                      <div className="col-xs-12 col-lg-8">
                        <h1 style={{ color: "green" }}>
                          {t("application_status.approved_title")}
                        </h1>
                      </div>
                    </div>
                    <div className="row">
                      {(approvedStatus?.toLowerCase() === "cheque_cashed" ||
                        approvedStatus?.toLowerCase() === "cheque_cleared") && (
                          <div className="col-xs-12 col-lg-8">
                            <h2 style={{ marginTop: 0, marginBottom: 0 }}>
                              {t("application_status.approved_check_cashed")}
                              {date}
                              <span>.</span>
                            </h2>
                            <span>{t("application_status.check_your_bank")}</span>
                          </div>
                        )}
                      {approvedStatus?.toLowerCase() === "approved" && (
                        <div className="col-xs-12 col-lg-8">
                          <h2 style={{ marginTop: 0, marginBottom: 0 }}>
                            {t("application_status.approved_check_mailed_1")}
                            {date}
                            {t("application_status.approved_check_mailed_2")}
                            <span>.</span>
                          </h2>
                          <span>{t("application_status.check_your_mail")}</span>
                        </div>
                      )}
                      {approvedStatus === "DIRECT_DEPOSIT_COMPLETE" && (
                        <div className="col-xs-12 col-lg-8">
                          <h2 style={{ marginTop: 0, marginBottom: 0 }}>
                            {t("application_status.approved_direct_deposit")}{" "}
                            {date}
                            <span>.</span>
                          </h2>
                          <span>{t("application_status.check_your_bank")}</span>
                        </div>
                      )}
                      {approvedStatus === "NOT_PAID" &&
                        approvedStatus?.substring(0, 6) !== "cheque" && (
                          <div className="col-xs-12 col-lg-8">
                            <h2 style={{ marginTop: 0, marginBottom: 0 }}>
                              {t("application_status.approved_deposit")}
                            </h2>
                            <span>
                              {t("application_status.approved_deposit_note")}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xs-12 col-lg-12">
                  <div className="row">
                    <div className="col-xs-12 col-lg-8">
                      <h3 style={{marginBottom: -5 }}>{t("otherGrantQuestions.questions")}</h3>
                      <h5>{t("application_status.contact_us")}</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(ApprovedApplication);
